export const materialsFilters = () => {
  const listBlock = $(".materials--list");

  if (!listBlock.length) {
    return;
  }

  const filters = listBlock.find(".materials--list--filters");
  const listContainer = listBlock.find(".materials--list__ul");
  const paginationContainer = listBlock.find(".materials--list--pagination");

  const updateMaterialsResults = function (paged) {
    var pageNumber = parseInt(paged, 10);
    if (isNaN(pageNumber) || pageNumber < 1) {
      pageNumber = 1;
    }

    $.ajax({
      type: "post",
      dataType: "json",
      url: localized_object.ajax_url,
      data: {
        action: "get_materials_form",
        year: $("#materials-filter--year").val(),
        cat: $("#materials-filter--category").val(),
        category_ids: listBlock.attr("data-category-ids") || "",
        material_ids: listBlock.attr("data-material-ids") || "",
        nonce: localized_object.nonce,
        paged: pageNumber,
      },
      timeout: 300000,
      beforeSend: function () {
        filters.addClass("is-loading");
        filters.css({ cursor: "wait" });
        filters.find("input, button, select, label").css({ cursor: "wait" });
      },
    })
      .done(function (response) {
        if (response && typeof response.materials !== "undefined") {
          if (response.materials.trim() === "") {
            listContainer.html(
              '<li class="materials--list--empty">No materials found. <a href="' + window.location.pathname + '">Clear filters</a></li>'
            );
            paginationContainer.hide();
          } else {
            listContainer.html(response.materials);

            if (response.pagination && response.pagination.trim() !== "") {
              paginationContainer.html(response.pagination).show();
            } else {
              paginationContainer.hide();
            }
          }
        }
      })
      .fail(function (request, status, err) {
        console.log("REQUEST => " + request);
        console.log("STATUS => " + status);
        console.log("ERR => ");
        console.log(err);
      })
      .always(function () {
        filters.removeClass("is-loading");
        filters.css({ cursor: "auto" });
        filters.find("input, button, select, label").css({ cursor: "auto" });
      });
  };

  paginationContainer.on("click", ".materials--list--pagination--list--item--link", function (e) {
    e.preventDefault();
    var pageElement = $(this).closest(".materials--list--pagination--list--item");
    var page = parseInt(pageElement.data("page"), 10);
    if (!isNaN(page) && page > 0) {
      updateMaterialsResults(page);
    }
  });

  paginationContainer.on("click", ".materials--list--pagination--prev:not(.is-disabled)", function (e) {
    e.preventDefault();
    var page = parseInt($(this).data("prev"), 10);
    if (!isNaN(page) && page > 0) {
      updateMaterialsResults(page);
    }
  });

  paginationContainer.on("click", ".materials--list--pagination--next:not(.is-disabled)", function (e) {
    e.preventDefault();
    var page = parseInt($(this).data("next"), 10);
    if (!isNaN(page) && page > 0) {
      updateMaterialsResults(page);
    }
  });

  $("#materials-filter--year").on("change", function () {
    updateMaterialsResults(1);
  });

  $("#materials-filter--category").on("change", function () {
    updateMaterialsResults(1);
  });
};
